import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static values = {
    url: String,
    turboFrame: String,
  };

  navigate(event) {
    // Don't navigate if clicking on interactive elements
    if (this.isInteractiveElement(event.target)) {
      return;
    }

    if (!this.urlValue) return;

    if (this.turboFrameValue) {
      Turbo.visit(this.urlValue, { frame: this.turboFrameValue });
    } else {
      Turbo.visit(this.urlValue);
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.navigate(event);
    }
  }

  select(event) {
    // Don't select if clicking on interactive elements
    if (this.isInteractiveElement(event.target)) {
      return;
    }

    this.element.classList.toggle("bg-brand-50");
    this.dispatch("selected", { detail: { row: this.element } });
  }

  isInteractiveElement(element) {
    const interactiveTags = ["A", "BUTTON", "INPUT", "SELECT", "TEXTAREA"];
    const current = element.closest(
      'a, button, input, select, textarea, [role="button"]'
    );
    return (
      interactiveTags.includes(element.tagName) ||
      current !== null ||
      element.hasAttribute("data-action")
    );
  }
}
